import { render } from "./Senarai.vue?vue&type=template&id=25adad28"
import script from "./Senarai.vue?vue&type=script&lang=js"
export * from "./Senarai.vue?vue&type=script&lang=js"

import "./Senarai.vue?vue&type=style&index=0&id=25adad28&lang=css"

import exportComponent from "/var/www/html/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__